import FormInput from "@components/Form/FormInput";
import FormTextarea from "@components/Form/FormTextarea";
import { StyledButton } from "@components/Styled/Button";
import { StyledH2, StyledXSmall } from "@components/Styled/Text";
import React from "react";
import { withQuestionsForm } from "./withQuestionsForm";

import { clsx } from "clsx";

const Wrapper = (props: any) => (
  <form
    {...props}
    className={clsx(
      props.className,
      "flex w-full flex-wrap px-midi text-hint md:px-zero md:text-body",
    )}
  />
);

const Header = (props: any) => (
  <StyledH2
    {...props}
    className={clsx(
      props.className,
      "mb-midi w-full text-center md:text-[44px]",
    )}
  />
);

const Column = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "w-full md:w-1/2 md:px-mini")}
  />
);

const Button = (props: any) => (
  <StyledButton
    {...props}
    className={clsx(props.className, "md:max-w-33 w-full")}
  />
);

const Input = (props: any) => (
  <FormInput
    {...props}
    className={clsx(
      props.className,
      "mb-midi h-auto px-zero",
      props.error &&
        "mb-zero [&_input]:border-b-2 [&_input]:border-warning [&_input]:text-warning",
    )}
  />
);

const TextareaWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "w-full md:px-mini")} />
);

const Textarea = (props: any) => (
  <FormTextarea
    {...props}
    className={clsx(
      props.className,
      "mb-midi px-zero",
      props.error &&
        "mb-zero [&_textarea]:border-b-2 [&_textarea]:border-warning [&_textarea]:text-warning",
    )}
  />
);

const ButtonWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex w-full flex-wrap items-center justify-center px-mini",
    )}
  />
);

const ErrorMessage = (props: any) => (
  <StyledXSmall
    {...props}
    className={clsx(props.className, "mb-mini mt-pico text-warning")}
  />
);

const Success = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex flex-col items-center justify-center py-midi md:py-mega",
    )}
  />
);

const Title = (props: any) => (
  <h2
    {...props}
    className={clsx(
      props.className,
      "mb-mini text-center font-display text-h2 md:text-[44px]",
    )}
  />
);

const Message = (props: any) => (
  <p
    {...props}
    className={clsx(
      props.className,
      "mx-auto mb-mini text-center leading-caption",
    )}
  />
);

const HelperTextContent = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "mb-midi flex w-full justify-center leading-body md:mb-maxi",
    )}
  />
);

const QuestionsForm = withQuestionsForm(
  ({
    data,
    handleChange,
    handleSubmit,
    className,
    loading,
    success,
    errors,
  }) => {
    return !success ? (
      <Wrapper className={className}>
        <Header>Ask a question</Header>
        <HelperTextContent className="rte">
          <div className="px-4 text-center">
            <p>Need your question answered sooner?</p>
            <p>
              <a href="/contact">Get in Touch</a>
            </p>
          </div>
        </HelperTextContent>
        <Column>
          <Input
            data-testid="name"
            label="Name"
            name="name"
            value={data.name}
            handleChange={handleChange}
            error={!!errors["name"]}
            required
          />
          {errors["name"] ? (
            <ErrorMessage>{errors["name"]}</ErrorMessage>
          ) : null}
        </Column>
        <Column>
          <Input
            data-testid="email"
            label="Email"
            name="email"
            value={data.email}
            handleChange={handleChange}
            error={!!errors["email"]}
            required
          />
          {errors["email"] ? (
            <ErrorMessage>{errors["email"]}</ErrorMessage>
          ) : null}
        </Column>
        <TextareaWrapper>
          <Textarea
            data-testid="question"
            label="Question"
            name="content"
            value={data.content}
            handleChange={handleChange}
            error={!!errors["content"]}
            required
          />
          {errors["content"] ? (
            <ErrorMessage>{errors["content"]}</ErrorMessage>
          ) : null}
        </TextareaWrapper>

        <ButtonWrapper>
          <Button
            height="56"
            textSize="16"
            colour="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting" : "Submit"}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    ) : (
      <Success>
        <Title>Thanks for your question!</Title>
        <Message>
          We love hearing from you. Our team will publish it shortly.
        </Message>
      </Success>
    );
  },
);

export default QuestionsForm;
